import React from "react";
import classes from "./MobileNav.module.css";
import { Link } from "react-router-dom";
import * as anchor from "@project-serum/anchor";
import discordImg from "../../assets/social-media-icons/discord.svg";
import twitterImg from "../../assets/social-media-icons/twitter.png";
import spaceKittiesImg from "../../assets/sk_logo_crop.png";
import img2 from "../../assets/Text_BattleMechs.png";

export interface NavProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

const MobileNav: React.FC = () => {
  return (
    <div className={classes["mobile-nav-inner"]}>
      <div>
        <img
          src={spaceKittiesImg}
          alt=""
          className={classes["mobile-nav-img"]}
        />
        <img
          src={img2}
          alt=""
          style={{ marginTop: "-1rem" }}
          className={classes["mobile-nav-img"]}
        />
      </div>
      <div className={classes["mobile-nav-btn"]}>
        <a
          href="https://www.magiceden.io/marketplace/spacekitties"
          target="_blank"
          rel="noreferrer"
        >
          Space Kitties on MagicEden
        </a>
      </div>
      <div className={classes["mobile-nav-btn"]}>
        <Link to="/game">Battle Mech Game</Link>
      </div>
      <div className={classes["mobile-socials-wrapper"]}>
        <a
          href="https://discord.gg/fpkXATuucr"
          target="_blank"
          rel="noreferrer"
        >
          <img className={classes["icon"]} src={discordImg} alt="icon" />
        </a>
        <a
          href="https://twitter.com/spacekittiesxyz"
          target="_blank"
          rel="noreferrer"
        >
          <img className={classes["icon"]} src={twitterImg} alt="icon" />
        </a>
      </div>
    </div>
  );
};

export default MobileNav;
